import io from "socket.io-client";

export const socket = io('https://lot6x45.xanhchin.io');